export default __webpack_public_path__ + "static/media/credex-web.49306d29.png";